import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Immutable from 'immutable';

const TradeOffersRequestedMobile = ({ tradeOffersRequested }) => {
  return (
    <Accordion accordion={ false }>
      {tradeOffersRequested.valueSeq().map((tradeOfferRequested) => (
        <AccordionItem key={ tradeOfferRequested.get('id') }>
          <AccordionItemTitle>
            <div className='u-position-relative'>
              <div>
                <div className={ 'accordion-header__title' }>Receiver</div>
                <div className={ 'accordion-header__item' }>{tradeOfferRequested.getIn(['receiver', 'name'])}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Offered Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferRequested.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferRequested.getIn(['offeredAppointment', 'from']))}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Requested Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferRequested.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferRequested.getIn(['requestedAppointment', 'from']))}</div>
              </div>
              <div className='accordion__arrow' role='presentation' />
            </div>
          </AccordionItemTitle>
          <AccordionItemBody>
            <div>
              <div className={ 'accordion-header__title' }>Office</div>
              <div className={ 'accordion-header__item' }>{tradeOfferRequested.getIn(['requestedAppointment', 'office', 'name'])}</div>
            </div>
            <div>
              <div className={ 'accordion-header__title' }>Status</div>
              <div className={ 'accordion-header__item trade-post__trade-status--accepted' }>{tradeOfferRequested.get('status')}</div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
      ))}
    </Accordion>

  );
};

TradeOffersRequestedMobile.propTypes = {
  tradeOffersRequested: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default TradeOffersRequestedMobile;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/accepted/TradeOffersRequestedMobile.jsx